import { render } from "./IconPen.vue?vue&type=template&id=ccfbb380"
const script = {}
script.render = render

export default script